import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LogRocket from 'logrocket';
import { BROKER_SEGMENT } from '@plataforma/utils';
// services
import { PoliciesAPI } from '@services/api';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import {
  changeBroker,
  getUserProfile,
  getBrokerHasConsultancy,
  getSegment
} from '@services/auth';

// utils
import { USER_TYPE } from '@plataforma/utils';
import { Tag } from '@plataforma/components';
import { showMenuItem } from '../../../utils/appbar';

// styles
import * as S from './styles';

const List = ({ customItems, onCloseMenu }) => {
  const [csv, setCsv] = useState(null);
  const [isFetchingCsv, setFetchingCsv] = useState(false);
  const userProfile = getUserProfile();
  const [brokerHasConsultancy, setBrokerHasConsultancy] = useState(false);
  const [isBrokerPlus, setIsBrokerPlus] = useState(false);

  useEffect(() => {
    const hasConsultancy = getBrokerHasConsultancy() ?? false;
    setBrokerHasConsultancy(hasConsultancy);

    const brokerSegment = getSegment();

    setIsBrokerPlus(brokerSegment === BROKER_SEGMENT.Plus);
  }, [setIsBrokerPlus]);

  /**
   * downloadCsv
   * receive a csvFile binary and transform it to a file and force it's download
   *
   * @param {binary} csvFile - the csv content
   */
  const downloadCsv = csvFile => {
    const hiddenElement = document.createElement('a');
    hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csvFile)}`;
    hiddenElement.target = '_blank';
    hiddenElement.download = 'processos.csv';
    hiddenElement.click();
  };

  const onRedirectHandler = () => {
    window.location = getSessionItem('PLATAFORMA_TOMADOR');
  };

  const openReportPageHandler = () => {
    window.location = `${getSessionItem('PLATAFORMA_TOMADOR')}reports`;
  };

  const onRedirectToMyAccount = () => {
    window.location = `${getSessionItem('PLATAFORMA_MINHA_CONTA')}`;
  };

  const onRedirectToMyConsultancy = () => {
    window.location = `${getSessionItem(
      'PLATAFORMA_ASSESSORIA'
    )}/my-consultancy`;
  };

  const onRedirectToAboutConsultancy = () => {
    window.location = `${getSessionItem('PLATAFORMA_ASSESSORIA')}/about`;
  };

  const onRedirectToBrokerDetails = () => {
    window.location = `${getSessionItem(
      'PLATAFORMA_ACCOUNT_UPDATE'
    )}select-affiliate`;
  };

  const getMenuItems = () => {
    const defaultMenu = [
      {
        title: 'Administrar tomadores',
        onClick: () => onRedirectHandler(),
        userType: 'ADMINISTRAR_TOMADORES'
      },
      {
        title: 'Administrar usuários',
        onClick: () => onRedirectToMyAccount(),
        userType: 'ADMINISTRAR_USUARIOS'
      },
      {
        title: 'Dados da corretora',
        onClick: () => onRedirectToBrokerDetails(),
        userType: 'DADOS_CORRETORA'
      },
      {
        title: 'Relatório tomador',
        onClick: () => openReportPageHandler(),
        userType: 'RELATORIO_TOMADOR'
      },
      ...(brokerHasConsultancy || isBrokerPlus
        ? [
            {
              title: 'Minha Assessoria',
              onClick: () =>
                brokerHasConsultancy
                  ? onRedirectToMyConsultancy()
                  : onRedirectToAboutConsultancy(),
              userType: 'ADMINISTRAR_ASSESSORIA'
            }
          ]
        : []),
      {
        title: 'Trocar corretor',
        onClick: () => changeBroker(),
        userType: 'TROCAR_CORRETOR'
      }
    ];

    // if it's a commercual user gets only the default menu, otherwise merge it with possible custom items
    const items =
      userProfile === USER_TYPE.commercial
        ? defaultMenu
        : [...customItems, ...defaultMenu];

    // filtered items based on access rights
    const filteredItems =
      items &&
      items.filter(menuItem => showMenuItem(userProfile, menuItem.userType));

    return (
      filteredItems.length > 0 && (
        <S.List data-testid="user-menu-list">
          {filteredItems.map((menu, index) => {
            const isConsultancyTitle = menu.title === 'Minha Assessoria';
            return (
              <S.Item
                key={`${menu.task}-${index}`}
                onClick={args => {
                  menu.onClick(args);
                  onCloseMenu();
                }}
              >
                <span>{menu.title}</span>
                {isConsultancyTitle && <Tag text="NOVO" />}
                {menu.hasLoader && isFetchingCsv && <S.Loader size="16" />}
              </S.Item>
            );
          })}
        </S.List>
      )
    );
  };

  return getMenuItems();
};

List.defaultProps = {
  customItems: []
};

List.propTypes = {
  customItems: PropTypes.array,
  onCloseMenu: PropTypes.func
};

export default List;
